import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Login from "./pages/(auth)/Login";
import Signup from "./pages/(auth)/Signup";
import Layout from "./pages/Layout";
import Chat from "./pages/Chat";
import Plans from "./pages/Plans";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/Payment/Success";
import PaymentFailure from "./pages/Payment/Failure";
import GetToKnowYouPage from "./pages/GetToKnowYou";
import DashboardLayout from "./pages/(dashboard)/Layout";
import DashboardHome from "./pages/(dashboard)/Home";
import Profile from "./pages/user/index.js";
import Victory from "./pages/(dashboard)/Victory";
import Learnings from "./pages/(dashboard)/Learnings";
import History from "./pages/(dashboard)/History";
import EmailVerification from "./pages/EmailVerification";
import ForgotPassword from "./pages/(auth)/Login/forgotPassword";
import SetPassword from "./pages/Auth/SetPassword";
import "./App.css";
import CoachDisclaimer from "./pages/Disclaimer";
import PlansProtectedRoute from "./components/PlansProtectedRoute";
import InstantChat from "./components/DialogueFlowMessenger/instantChat";
import { ThemeProvider } from "./context/ThemeContext";
import Presell from "./pages/Presell/Presell.js";
import Waitlist from "./pages/Presell/Waitlist.js";

export default function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/">
          {/* <Route index element={<Home />} /> */}
          <Route index element={<Waitlist />} />
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="/instant-chat" element={<InstantChat />} />
          <Route path="100foundingmembers" element={<Presell />} />
          <Route path="waiting-list" element={<Waitlist />} />
          <Route element={<Layout />}>
            {/* Plans route with custom protection logic */}
            <Route
              path="our-plans"
              element={
                <PlansProtectedRoute>
                  <Plans />
                </PlansProtectedRoute>
              }
            />
            
            <Route path="checkout" element={<Payment />} />
            <Route path="paymentSuccessful" element={<PaymentSuccess />} />

            {/* Protected Routes */}
            <Route
              element={
                <ProtectedRoute>
                  <Outlet />
                </ProtectedRoute>
              }
            >
              <Route path="paymentFailed" element={<PaymentFailure />} />
              <Route path="disclaimer" element={<CoachDisclaimer />} />
              <Route path="profile" element={<Profile/>} />
              <Route path="dashboard" element={<Chat />} />
            </Route>
            <Route path="verify-email" element={<EmailVerification />} />
            <Route path="set-password" element={<SetPassword />} />
          </Route>
        </Route>
      </Routes>
    </ThemeProvider>
  );
}
